import { ExclusiveLabel } from "@components/ExclusiveLabel";
import { Row } from "@components/Flex";
import { ProgressBar } from "@components/ProgressBar";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { BeneficiaryType, Routes } from "@ctypes";
import { i18n, Translations } from "@i18n";
import { formatCurrency } from "@utils";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";
import { ProgressCardProps } from "./types";

export const ProgressCard = ({
  id,
  name,
  type,
  goalsLength,
  currentAmount: currentAmountValue,
  projectedAmount: projectedAmountValue,
}: ProgressCardProps) => {
  const styles = useStyles();

  const navigate = useNavigate();

  if (!projectedAmountValue) return null;

  const goalsLengthText =
    goalsLength === 1
      ? i18n.t(Translations.AccountsRouteOneGoal)
      : i18n.t(Translations.AccountsRouteGoalsLength, { goalsLength });

  const currentAmount = formatCurrency(currentAmountValue);
  const projectedAmount = formatCurrency(projectedAmountValue);

  const progress = currentAmountValue / projectedAmountValue;

  const onClick = () => {
    navigate(Routes.GoalsOverview, { state: { beneficiaryId: id } });
  };

  return (
    <>
      <div style={styles.container} onClick={onClick}>
        <Row>
          <Title4 style={styles.text}>{name}</Title4>
          {type === BeneficiaryType.Self ? (
            <ExclusiveLabel>{i18n.t(Translations.AccountsRouteYouLabel)}</ExclusiveLabel>
          ) : null}
        </Row>
        <Spacing size={SpacingSizes.S} />

        <Body style={styles.goals}>{goalsLengthText}</Body>
        <Spacing size={SpacingSizes.S} />

        <Body style={styles.amount}>
          <span style={styles.current}>{currentAmount}</span>
          <span style={styles.projected}>
            {i18n.t(Translations.AccountsRouteOrLabel, { projectedAmount })}
          </span>
        </Body>
        <Spacing size={SpacingSizes.XS} />

        <ProgressBar progress={progress} />
        <Spacing size={SpacingSizes.XXS} />
      </div>
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
